import { request } from './client';

export const apiGetAllMessages = (page = 1, limit = 20, status = '') => {
  const params = new URLSearchParams({ page: String(page), limit: String(limit) });
  if (status) params.set('status', status);
  return request(`/contact?${params.toString()}`);
};

export const apiUpdateMessageStatus = (id, status) =>
  request(`/contact/${id}/status`, { method: 'PUT', body: { status } });

export const apiDeleteMessage = (id) =>
  request(`/contact/${id}`, { method: 'DELETE' });
